export default __webpack_public_path__ + "64f8b35b6c80f4b77fdc090d3cd9f616.ttf";